"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextOptionsField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class TextOptionsField extends EditorFieldBase_1.EditorFieldBase {
}
exports.TextOptionsField = TextOptionsField;
